<template>
    <div class="reg-temp-content-area p-3 main-content-height">
  
        <div class="row">
          

          <div class="col-sm-12 col-md-12" v-if="loading">
            <p class="text-center mt-5 mt-5 pt-5">Loading please wait...</p>
          </div>


          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" v-else >

            <div v-if="modalData.active" class="custom-popup-modal  active">
                <div class="custom-modal-wrapper">
                    <div class="customer-model-content add-new-product-model text-white">
                        <button  class="close-btn" @click.prevent="closeModal">X</button>
                        <div class="login-content add-product-wrapper">
                            <div class="w-full">
                                <h3 class="mb-2 text-left  w-full">{{ modalData.obj.company }}</h3>
                            </div>
                            <table class="table">
                                <tr>
                                    <td class="text-white text-left">Name</td>
                                    <td class="text-white text-left">
                                        {{ modalData.obj.fname + ' ' + modalData.obj.lname }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-white text-left">Email:</td>
                                    <td class="text-white text-left"><a class="text-white" :href="'mailto:'+(modalData.obj.email ? modalData.obj.email : '#')">{{ modalData.obj.email ? modalData.obj.email : ''}}</a></td>
                                </tr>
                                <tr>
                                    <td class="text-white text-left">Mobile:</td>
                                    <td class="text-white text-left">{{ modalData.obj.mobile ? modalData.obj.mobile : ''}}</td>
                                </tr>
                                <tr>
                                    <td class="text-white text-left">Address:</td>
                                    <td class="text-white text-left">{{ modalData.obj.address ?  modalData.obj.address : ''}}</td>
                                </tr>
                            </table>
                            
                        </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- map-type-id="satellite" -->
           
            <div v-if="resellers.length > 0">
                <GmapMap
                :center="center"
                :zoom="10"
                style="width: 100%; height: calc(100vh - 120px)"
                v-bind:options="mapStyle"
               
                >
                <!-- <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                    Test
                </gmap-info-window> -->

                

                <GmapMarker
                    :key="index"
                    v-for="(m, index) in resellers"
                    :position="m.position"
                    :clickable="true" 
                    @click="toggleInfoWindow(m)"
                    @mouseover="showByIndex = index;"
                    @mouseout="showByIndex = null"
                >
                <gmap-info-window
                    :opened="showByIndex === index"
                >
                    {{ m.company ? m.company : '' }}
                </gmap-info-window>
                </GmapMarker>


                </GmapMap>
            </div>
            <p  v-else>Sorry no reseller found.</p>
          </div>
    
  
          
  
        </div>
       
  
       
    </div>
  </template>
  
  <script>
  import AuthApis from '@/controllers/AuthApis';
  import Env from '@/env';
  
  import { mapGetters, mapActions } from "vuex";
  
  export default {
    name: 'distributorCustomerList',
    components: {
      
    },
    data(){
      return {
        mapStyle:{
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#ebe3cd"
                    }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#523735"
                    }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                    {
                        "color": "#f5f1e6"
                    }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                    {
                        "color": "#c9b2a6"
                    }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "geometry.stroke",
                    "stylers": [
                    {
                        "color": "#dcd2be"
                    }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#ae9e90"
                    }
                    ]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#f0f1f2"
                    }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#f0f1f2"
                    }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#93817c"
                    }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [
                    {
                        "color": "#a5b076"
                    }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#447530"
                    }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#f5f1e6"
                    }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#fdfcf8"
                    }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#f8c967"
                    }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                    {
                        "color": "#e9bc62"
                    }
                    ]
                },
                {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#e98d58"
                    }
                    ]
                },
                {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry.stroke",
                    "stylers": [
                    {
                        "color": "#db8555"
                    }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#806b63"
                    }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#f0f1f2"
                    }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#8f7d77"
                    }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                    {
                        "color": "#ebe3cd"
                    }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                    {
                        "color": "#f0f1f2"
                    }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                    {
                        "color": "#b9d3c2"
                    }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                    {
                        "color": "#92998d"
                    }
                    ]
                }
                ]
        },
        showByIndex: null,
        modalData: {
            obj: {},
            active: false,
        },
        center: {
            lat: -26.3104228, 
            lng: 28.046419 
        },
        loading: false,
        resellers: [],
        infoContent: '',
          infoWindowPos: null,
          infoWinOpen: true,
          currentMidx: null,
          //optional: offset infowindow so it visually sits nicely on top of our marker
          infoOptions: {
            pixelOffset: {
              width: 0,
              height: -35
            }
          },
      };
    },
    watch:{
    
    },

    computed: {
        ...mapGetters({
            vg_user: "auth/user",
        })
    },
  
    mounted() {
        if(this.vg_user.user_metas && this.vg_user.user_metas.lat && this.vg_user.user_metas.lng )  {
            this.center = {
                lat:  Number(this.vg_user.user_metas.lat), 
                lng:  Number(this.vg_user.user_metas.lng)
            };
        }
      this.fetchReseller();
    },
  
    methods: {
        closeModal() {
            this.modalData = {
                obj: {},
                active: false,
            }
        },

        toggleInfoWindow(m) {
            console.log(m)

            this.modalData = {
                obj: m,
                active: true,
            }
           
        },
    
      /**
       * Fetch page data
       */
       fetchReseller(){

        this.loading = true;
        const url = `${Env.baseUrl}/distributor/resellers/all`;
        AuthApis.getApi(url).then(res => {

          res.data.payload.map( m  =>  {
            if(m.user_metas.lat && m.user_metas.lng) {
                m.position  = {
                    lat: parseFloat(m.user_metas.lat),
                    lng: parseFloat(m.user_metas.lng)
                };
                m.infoText = m.fname;
            }
          });
          this.resellers =  res.data.payload
          this.loading = false;
        }).catch(err => {
          console.log(err)
          this.loading = true;
        })
       
      },
  

  
      ...mapActions({
        va_setDeleteModal: "distributor_customer/setDelete",
        va_setDeleteObj: "distributor_customer/setDeleteObj",
        va_setEditModal: "distributor_customer/setEdit",
        va_setEditObj: "distributor_customer/setEditObj",
        va_pdfModal: "pdf/setActive",
        va_pdfModalObj: "pdf/setActiveObj",
      }),
    
    }
  };
  </script>
<style>
button.gm-ui-hover-effect {
    visibility: hidden;
}
</style>